import { FormInput, InfoBox, TabsNavigation } from 'components/molecules';
import LabeledProviderConnectionStatus from 'components/molecules/labeledStatus/LabeledProviderConnectionStatus';
import { TopBar } from 'components/organisms';
import { TopbarTabs } from 'components/templates';
import { Form, Formik, FormikConfig } from 'formik';
import { useTranslation } from 'react-i18next';
import {
  IProviderBlobConnectionResponse,
  WEB_PROTOCOL,
} from 'services/providers/types';
import { II18nextPrefix } from 'types/components/components.interface';
import { useEnumToSelectOptions } from 'utils/components/inputs/select';
import { getTabError } from 'utils/global/validation.utils';
import * as Yup from 'yup';
import { IFormikProps, IFormProps } from '../types';
import BlobConnectionKyesTab from './tabs/BlobConnectionKyesTab';

export const blobConnectionInitialValue: IProviderBlobConnectionResponse = {
  version: 0,
  id: '',
  salesChannelId: '',
  providerId: '',
  isPredefined: false,

  serverFolder: '',

  //
  completedServerFolder: '',

  //
  connectionStatusId: null,
  healthCheckDate: null,
  //
  accountName: '',
  containerName: '',
  blobMainPath: '',
  accountKey: '',
  endpointSuffix: '',
  defaultEndpointsProtocolId: WEB_PROTOCOL.HTTPS,
};

const blobConnectionValidationSchema = Yup.object().shape({
  // serverAddress: Yup.string().required(() =>
  //   i18next.t('formik-error.required')
  // ),
});

export enum BlobConnectionTabs {
  keys,
}

export interface BlobConnectionFormProps
  extends FormikConfig<IProviderBlobConnectionResponse>,
    IFormProps,
    II18nextPrefix {}

const BlobConnectionForm = ({
  i18nextPrefix,
  topbarContent,
  tittle,
  status,
  initialValues = blobConnectionInitialValue,
  backPath,
  customBackItem,
  disableTabs,
  onSubmit,
  ...props
}: BlobConnectionFormProps) => {
  const { t } = useTranslation();
  const { getSelectOptions } = useEnumToSelectOptions();

  return (
    <Formik
      {...props}
      initialStatus={status}
      validateOnChange={true}
      validateOnBlur={true}
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={blobConnectionValidationSchema}
      onSubmit={onSubmit}>
      {({
        values,
        status,
        errors,
        setFieldValue,
      }: IFormikProps<IProviderBlobConnectionResponse>) => (
        <Form className='w-full h-full'>
          <TopbarTabs>
            <TopBar
              // title={status?.displayMode ? values.serverAddress : undefined}
              customBackItem={customBackItem}
              path={backPath}
              topbarContent={
                <div className='w-full flex justify-between items-center'>
                  <div className='w-60'>
                    <FormInput.Text
                      name='accountName'
                      label={t('input.label.accountName')}
                      autoFocus
                    />
                  </div>

                  <div className='flex items-center gap-2'>
                    {values.connectionStatusId !== null &&
                      status?.displayMode && (
                        <LabeledProviderConnectionStatus
                          status={values.connectionStatusId}
                        />
                      )}
                    {/* {status?.displayMode ? (
                      <LabeledStatus.Active status={initialValues.isActive} />
                    ) : (
                      <div className='w-44'>
                        <FormInput.Select
                          name='isActive'
                          label={t('input.label.active')}
                          options={getSelectOptions(
                            ACTIVE_STATUS,
                            'enum.ACTIVE_STATUS'
                          )}
                          isDisabled={
                            !status?.displayMode && values.isPredefined
                          }
                        />
                      </div>
                    )} */}
                    {topbarContent}
                  </div>
                </div>
              }>
              <InfoBox loading={status?.isLoading}>
                <InfoBox.Items columns={2}>
                  <FormInput.Text
                    name='containerName'
                    label={t('input.label.containerName')}
                  />
                  <FormInput.Text
                    name='blobMainPath'
                    label={t('input.label.blobMainPath')}
                  />
                  <FormInput.Text
                    name='endpointSuffix'
                    label={t('input.label.endpointSuffix')}
                  />

                  <FormInput.Text
                    name='serverFolder'
                    label={t('input.label.serverFolder')}
                  />
                  <FormInput.Select
                    name='defaultEndpointsProtocolId'
                    label={t('input.label.defaultEndpointsProtocolId')}
                    options={[
                      { label: 'http', value: WEB_PROTOCOL.HTTP },
                      { label: 'https', value: WEB_PROTOCOL.HTTPS },
                    ]}
                  />
                </InfoBox.Items>
              </InfoBox>

              <TabsNavigation
                tabs={[
                  {
                    value: BlobConnectionTabs.keys,
                    name: 'keys',
                    error: getTabError([
                      errors.accountKey,
                      // errors.keyPassphrase,
                      // errors.keyPath,
                      // errors.keyPrint,
                      // errors.sshHostKeyPolicyId,
                    ]),
                  },
                ]}
                i18nextPrefix={'provider'}
                disabled={disableTabs}
              />
            </TopBar>
          </TopbarTabs>
        </Form>
      )}
    </Formik>
  );
};

BlobConnectionForm.getRouterTabs = (disabledChildren?: string[]) =>
  [{ path: 'keys', element: <BlobConnectionKyesTab /> }].filter(
    children => !disabledChildren?.includes(children.path)
  );

export default BlobConnectionForm;
